import api from "./api";
import {
  ApiResponse,
  HakkimizdaBaslik,
  HakkimizdaBaslikCreateDTO,
  HakkimizdaBaslikUpdateDTO,
  HakkimizdaGorsel,
  HakkimizdaGorselUpdateDTO,
} from "./types";

export const HakkimizdaService = {
  baslikListele: async () => {
    const response = await api.get<ApiResponse<HakkimizdaBaslik[]>>(
      "/api/Hakkimizda/BaslikListele"
    );
    return response.data;
  },

  baslikDetay: async (id: string) => {
    const response = await api.get<ApiResponse<HakkimizdaBaslik>>(
      `/api/Hakkimizda/BaslikDetay/${id}`
    );
    return response.data;
  },

  baslikEkle: async (data: HakkimizdaBaslikCreateDTO) => {
    const response = await api.post<ApiResponse<HakkimizdaBaslik>>(
      "/api/Hakkimizda/BaslikEkle",
      data
    );
    return response.data;
  },

  baslikGuncelle: async (data: HakkimizdaBaslikUpdateDTO) => {
    const response = await api.put<ApiResponse<HakkimizdaBaslik>>(
      "/api/Hakkimizda/BaslikGuncelle",
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  baslikSil: async (id: string) => {
    const response = await api.delete<ApiResponse<boolean>>(
      `/api/Hakkimizda/BaslikSil/${id}`
    );
    return response.data;
  },

  gorselGetir: async () => {
    const response = await api.get<ApiResponse<HakkimizdaGorsel[]>>(
      "/api/Hakkimizda/Gorsel"
    );
    return response.data;
  },

  gorselGuncelle: async (data: HakkimizdaGorselUpdateDTO) => {
    const formData = new FormData();
    formData.append("id", data.id);
    formData.append("kapakGorsel", data.kapakGorsel);
    if (data.form) {
      formData.append("form", data.form);
    }

    const response = await api.put<ApiResponse<HakkimizdaGorsel>>(
      "/api/Hakkimizda/GorselGuncelle",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
};
